/**
 * Win amounts inside a book are bet multipliers in hundredths — 4000 is 40x the
 * bet, not a currency amount — so what a win actually pays only exists once it
 * is resolved against the bet the round was played at.
 */
const WIN_MULTIPLIER_UNITS = 100;

/** A book win amount as the bet multiplier it stands for (4000 -> 40). */
export function winToMultiplier(win: number): number {
    return win / WIN_MULTIPLIER_UNITS;
}

/**
 * What a book win amount pays at the given bet. The bet is a raw RGS amount
 * (1_000_000 -> 1.00), so the payout comes back in raw units too — the same
 * units the RGS reports a round's own `payout` in.
 */
export function winToPayout(win: number, betAmount: number): number {
    return winToMultiplier(win) * betAmount;
}
